import React from "react";
import { useResearchContext } from "layouts/user/Research/ResearchContext.provider";

export const FollowUpQuestionList = () => {
  const { state, actions } = useResearchContext();
  const { chat, longReportType, defaultFollowUpQuestions } = state;
  const { setChatMessage, setMultiple } = actions;

  const handleQuestionClick = (question: string) => {
    setChatMessage(question);
    setMultiple({ autocomplete: false });
  };

  return (
    <>
      {
        chat.length == 0 && defaultFollowUpQuestions.hasOwnProperty(longReportType) && 
        (defaultFollowUpQuestions[longReportType]).map((question, index) => (
          <div 
            className="research__form__followup" 
            key={index} 
            onClick={() => handleQuestionClick(question)} 
            dangerouslySetInnerHTML={{ __html: question }}> 
            </div>
        ))
      }
    </>
  );
};
